<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
  </div>
</template>
<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import WepFooter from '~pages/layouts/WepFooter'
import WepForum from '~pages/layouts/WepForum'

export default {
  name: 'MainHome',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate,
    swiper,
    swiperSlide,
    WepFooter,
    WepForum
  },
  data () {
    return {
      includeHtml: '',
      visible: false,
      videoSrc: '',
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      },
      fullpageOptions: {
        licenseKey: '5D25061B-0D0F4A28-952B9FF0-A0E49441',
        navigation: true,
        sectionsColor: ['', '', '#090a0e', '', '#282a39'],
        normalScrollElements: '.popup-open',
        scrollOverflow: true,
        anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10']
      },
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 18,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 12
          },
          720: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        },
        watchSlidesVisibility: true
      },
      swiperOption2: {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          720: {
            slidesPerView: 'auto'
          }
        },
        navigation: {
          nextEl: '.swiper-nav-next',
          prevEl: '.swiper-nav-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchSlidesVisibility: true
      },
      speakerSwiperSet: {
        slidesPerView: 3,
        spaceBetween: 120,
        breakpoints: {
          // 2021-03-02 : 사이즈 변경 tablet 옵션 추가 및 수정
          720: {
            slidesPerView: 'auto',
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 36
          }
        },
        navigation: {
          nextEl: '.speaker-list .swiper-next',
          prevEl: '.speaker-list .swiper-prev'
        },
        watchSlidesVisibility: true
      },
      programSwiperSet: {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          // 2021-03-02 : tablet 옵션 추가 및 수정
          720: {
            spaceBetween: 80
          },
          1024: {
            spaceBetween: 124
          }
        },
        watchSlidesVisibility: true
      },
      forumSwiperSet: {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          // 2021-03-02 : tablet 옵션 추가 및 수정
          720: {
            slidesPerView: 'auto'
          }
        },
        navigation: {
          nextEl: '.swiper-nav-next',
          prevEl: '.swiper-nav-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchSlidesVisibility: true
      },
      basePath: this.getStore('mmpAuth').state.basePath,
      isEnter: this.$route.meta.isEnter,
      loginNm: '',
      wepSets: this.getStore('mmpAuth').state.wepSets,
      loginType: 'L',
      ptptAplTyp: this.getStore('mmpAuth').state.wepSets.ptptAplTyp,
      isStatusOn : true
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    },
    isLogin () {
      let isLogin = false
      let tokenStore = window.vue.getStore('token')
      let rootStore = window.vue.getStore('root')

      if (rootStore !== null && rootStore.getters.getSession.authenticated && tokenStore.getters.getTokenAuth) {
        isLogin = false
      } else {
        isLogin = true
      }
      return isLogin
    }
  },
  mounted () {
    setTimeout(function () {
      try {
        this.fullpage_api.reBuild()
      } catch (e) {
      }
    }, 1500)
    this.fnBrowser()
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepMainHome.html')
    } else if (wepHtmlToString.mainTemplateFile !== 'wepMainHome.html') {
      this.getEmptyTemplate('wepMainHome.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }
    this.getMainType()
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    fnForum () {
      this.getTemplate('wepForum.html', '0', 'forum')
    },

    toggleOnOff () {
      this.isStatusOn = !this.isStatusOn
    },
    
    async getMainType () {
      let params = {
        wepId: this.getStore('mmpAuth').state.saveId,
        langId: localStorage.getItem('language')
      }
      let resultInfo = await this.$http.mmp.getTzTime(this, params)
      let currDay = resultInfo.data.data
      if (this.wepSets.mocktUseYn === 'Y' && currDay >= this.wepSets.mocktStartDtm && currDay <= this.wepSets.mocktEndDtm) {
        this.loginType = 'M'
        this.isEnter = true
      } else if (currDay >= this.wepSets.videoTrnsStartDtm && currDay <= this.wepSets.videoTrnsEndDtm) {
        this.loginType = 'L'
        this.isEnter = true
      } else if (currDay >= this.wepSets.ptptAplStartDtm && currDay <= this.wepSets.ptptAplEndDtm && this.ptptAplTyp === 'PO') {
        this.loginType = 'E'
        this.isEnter = true
      } else {
        this.isEnter = false
      }
    },
    async fnLogin () {
      let params = {
        wepId: this.getStore('mmpAuth').state.saveId,
        langId: localStorage.getItem('language')
      }
      let resultInfo = await this.$http.mmp.getTzTime(this, params)
      let currDay = resultInfo.data.data
      if (currDay >= this.wepSets.videoTrnsStartDtm && currDay <= this.wepSets.videoTrnsEndDtm) {
        if (this.isLogin) {
          this.getTemplate('wepOnAir.html', '0', 'onAir')
        } else {
          this.getTemplate('wepEnter.html', '0', 'enter')
        }
      } else if (this.wepSets.mocktUseYn === 'Y' && currDay >= this.wepSets.mocktStartDtm && currDay <= this.wepSets.mocktEndDtm) {
        if (this.isLogin) {
          this.getTemplate('wepOnAir.html', '0', 'onAir')
        } else {
          this.getTemplate('wepEnter.html', '0', 'enter')
        }
      } else {
        this.commAlert(this.$t('WEP00019'))
      }
    },
    async fnSurvey () {
      let params = {
        wepId: this.getStore('mmpAuth').state.saveId,
        langId: localStorage.getItem('language')
      }
      let resultInfo = await this.$http.mmp.getTzTime(this, params)
      let currDay = resultInfo.data.data

      if (currDay >= this.wepSets.ptptAplStartDtm && currDay <= this.wepSets.ptptAplEndDtm) {
        this.getTemplate('wepSurvey.html', '1')
        this.getTemplate('wepRegister.html', '2')
        this.getTemplate('wepComplete.html', '3')
        this.getTemplate('wepConfirm.html', '4')
        this.getTemplate('wepResult.html', '5' )
        this.getTemplate('wepResult2.html', '6', 'surveyConfirm')
      } else {
        this.commAlert(this.$t('WEP00020'))
      }
    },
    fnBrowser () {
      let agent = window.navigator.userAgent.toLowerCase()
      let appName = window.navigator.appName.toLowerCase()
      let isBrowser = this.$t('IS_BROWSER')
      if (isBrowser === 'Y') {
        let wepUrl = window.location.href
        // IE일 경우 엣지 실행
        if ((appName === 'netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1) {
          let param = {'linkUrl': wepUrl, 'targetNm': ''}
          let _this = this
          setTimeout(function () {
            _this.$popup.browserLink(_this.$el, param)
          }, 1000)
        }
      }
    },
    fnFullPageScroll (isScroll) {
      setTimeout(function () {
        try {
          this.fullpage_api.setAllowScrolling(isScroll)
        } catch (e) {
          // alert(e)
        }
      }, 200)
    },
    moveSectionDown () {
      setTimeout(function () {
        try {
          this.fullpage_api.moveSectionDown()
        } catch (e) {
          // alert(e)
        }
      }, 100)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/MainHome.vue